import SubcategoriesLists from './SubcategoriesLists';

export default SubcategoriesLists;
